import { getPosts } from '../components/getPosts';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { addActiveOption, handleDisableFilter, handleRestart } from '../components/activeFilters';

gsap.registerPlugin(ScrollTrigger);
const $ = jQuery;
const $section = $('section.archive-news');
const postContainer = $section.find('.js-archive--posts');
const postsPerPage = 9;

export default function () {
    if (!$section.length) return;

    const $options = $section.find('.js-filter-dropdown--option');
    if (!$options.length) return;

    handleSearchTrigger();
    handleLoadMore();
    handleRestart(handlePosts);
    handleDisableFilter(handlePosts);

    $options.on('click', function () {
        handlePosts();
        addActiveOption($(this));
    });
}

const handleSearchTrigger = () => {
    let debounceTimer;

    $section.find('.js-archive--search input').on('keyup', function (e) {
        let query = $(this).val().trim();

        if (e.key === 'Enter') {
            handlePosts();
            return;
        }

        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
            if (query.length > 3 || query.length === 0) {
                handlePosts();
            }
        }, 300);
    });
};

let isLoadMore = false;
const handlePosts = (loadMore = false, postIds = []) => {
    isLoadMore = loadMore;
    const data = {
        action: 'get_news',
        taxonomies: getActiveFilterData(),
        search: getActiveSearchData(),
        isLoadMore,
        postIds,
    };

    getPosts(data, handlePostsBefore, handleSuccess);
};

const handlePostsBefore = () => {
    postContainer.addClass('loading');
};

const handleSuccess = (data) => {
    data = JSON.parse(data);
    const $posts = $section.find('.js-archive--posts');

    if (!isLoadMore) {
        if (!data.posts) {
            $posts.html('');
        } else {
            $posts.html(data.posts);

            if (data.total > postsPerPage) {
                handleLoadMore();
            } else {
                disableLoadMoreGsap();
            }
        }
    } else {
        $posts.append(data.posts);

        if (data.total <= postsPerPage) {
            disableLoadMoreGsap();
        }
    }

    postContainer.removeClass('loading');
    ScrollTrigger.refresh();
};

const getTotalPosts = () => {
    const $posts = $section.find('.js-archive--posts');
    const $totalPosts = $posts.find('.card-post').length;
    return $totalPosts;
};

const getActiveFilterData = () => {
    const filters = [];
    const $filters = $section.find('.js-filter-dropdown');

    $filters.each(function () {
        const $filter = $(this);
        const $activeOption = $filter.find('.js-filter-dropdown--option.selected');
        const name = $filter.data('name');
        const value = $activeOption.data('value');

        filters.push({
            name,
            value,
        });
    });

    return filters;
};

const getActiveSearchData = () => {
    const $input = $section.find('.js-archive--search input');
    const searchData = $input.val();
    return searchData;
};

let loadMoreScrollTrigger = null;
const handleLoadMore = () => {
    if (getTotalPosts() < postsPerPage || $('.no-result').length) return;

    loadMoreScrollTrigger = gsap.to(postContainer, {
        scrollTrigger: {
            trigger: postContainer,
            start: '80% bottom',
            onEnter: () => {
                const $posts = postContainer.find('.card-post');
                const postIds = $posts
                    .map(function () {
                        return $(this).data('id');
                    })
                    .get();

                handlePosts(true, postIds);
            },
        },
    }).scrollTrigger;
};

const disableLoadMoreGsap = () => {
    if (loadMoreScrollTrigger) {
        loadMoreScrollTrigger.kill();
    }
};
